import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CONTACT, NAV_LINKS } from "../data/content";
import { DotStrip } from "./Brand";
import { FadeUp } from "./Motion";

const Footer = () => (
  <footer className="border-t border-white/10 bg-nexa-black" data-testid="site-footer">
    <DotStrip className="text-nexa-red/70" />
    <div className="mx-auto max-w-[1600px] px-5 py-20 md:px-10 md:py-28">
      <FadeUp>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-nexa-bone/50">Got a brand that needs teeth?</p>
        <Link
          to="/contact"
          data-testid="footer-cta-talk"
          className="group mt-4 block font-display uppercase leading-[0.9] text-nexa-bone transition-colors duration-300 hover:text-nexa-red"
        >
          <span className="block text-[18vw] md:text-[10rem]">Let's</span>
          <span className="block text-[18vw] md:text-[10rem]">
            Talk<span className="text-nexa-red transition-colors duration-300 group-hover:text-nexa-bone">.</span>
          </span>
        </Link>
      </FadeUp>

      <div className="mt-16 grid gap-10 border-t border-white/10 pt-10 md:grid-cols-3">
        <div>
          <img src="/brand/wm-horizontal-red.svg" alt="Nexa Studio" width="65" height="32" className="h-8 w-auto" />
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-nexa-bone/60">
            An attack unit for brands. Built on 12 years of Myndroot's battle tested portfolio.
          </p>
          <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-nexa-bone/40">Also from the Den</p>
          <a
            href="https://nexawears.in"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-family-nexa-wears"
            className="link-line mt-2 inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-[0.15em] text-nexa-red hover:text-nexa-bone"
          >
            Nexa Wears — nexawears.in <ArrowUpRight size={12} />
          </a>
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.15em] text-nexa-bone/60">
          <p className="text-nexa-red">Den</p>
          <p className="mt-3 leading-relaxed normal-case tracking-normal font-body text-sm text-nexa-bone/70">{CONTACT.address}</p>
          <a href={`mailto:${CONTACT.email}`} className="link-line mt-3 inline-block text-nexa-bone/80" data-testid="footer-email-link">
            {CONTACT.email}
          </a>
          <br />
          <a href={`tel:${CONTACT.phoneRaw}`} className="link-line mt-1 inline-block text-nexa-bone/80" data-testid="footer-phone-link">
            {CONTACT.phone}
          </a>
          <br />
          <a href={`tel:${CONTACT.phone2Raw}`} className="link-line mt-1 inline-block text-nexa-bone/80" data-testid="footer-phone2-link">
            {CONTACT.phone2}
          </a>
        </div>
        <nav className="flex flex-col gap-2 font-mono text-xs uppercase tracking-[0.15em]" aria-label="Footer">
          {NAV_LINKS.map((l) => (
            <Link key={l.path} to={l.path} className="link-line w-fit text-nexa-bone/60 hover:text-nexa-bone" data-testid={`footer-link-${l.label.toLowerCase()}`}>
              {l.label}
            </Link>
          ))}
          <a
            href="https://nexawears.in"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-link-nexa-wears"
            className="link-line inline-flex w-fit items-center gap-1 text-nexa-red hover:text-nexa-bone"
          >
            Nexa Wears <ArrowUpRight size={12} />
          </a>
        </nav>
      </div>

      <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-nexa-bone/40 md:flex-row md:justify-between">
        <p>© 2026 Nexa Studio. Born from Myndroot.</p>
        <p>Kolkata, India — {CONTACT.site}</p>
      </div>
    </div>

    <div className="overflow-hidden border-t border-white/10 py-8" data-testid="footer-bumper-wordmark">
      <div className="flex justify-center px-5">
        <img src="/brand/wm-horizontal-white.svg" alt="Nexa Studio" style={{ aspectRatio: "700/344" }} className="w-full max-w-[1100px] opacity-10" />
      </div>
    </div>
  </footer>
);

export default Footer;
